import Vue, { PropType } from 'vue';
import { SmartSuggestV4 } from '../../../../declarations/request';

const product = Vue.component('fl-product', {
    template: `
      <a
          class="fl-as-product fl-pure-sm-1-2 fl-pure-md-1-2 fl-pure-lg-1-2 fl-pure-xl-1-4"
          :href="utils.addQueryParams(product.url, trackingParameters)"
      >
        <div class="fl-as-product-container fl-w-100">
          <img
            class="fl-as-product-image"
            :src="product.imageUrl"
            :alt="product.text"
            onerror="this.onerror=null;this.src='https://cdn.findologic.com/login.symfony/web/images/image_not_found.png';"
          >
          <p
              class="fl-as-product-text"
              v-html="productName"
          />
          <div
            v-if="config.assistedSuggest.config.showPrices"
            class="fl-as-product-price-container"
          >
              <p
                  v-if="oldPrice && oldPrice > product.price"
                  class="fl-as-product-price fl-as-product-old-price"
                  v-text="utils.formatPrice(oldPrice)"
              />
              <p
                  class="fl-as-product-price"
                  v-text="utils.formatPrice(product.price)"
              />
          </div>
        </div>
      </a>`,
    props: {
        product: Object as PropType<SmartSuggestV4.Product>,
    },
    inject: ['config', 'HandleInteractionService', 'HandleShopInteractionService', 'utils'],
    computed: {
        oldPrice(): number {
            const value = this.product.properties[this.config.assistedSuggest.config.oldPriceProperty];

            return isNaN(value) ? 0 : parseFloat(value);
        },
        productName(): string {
            return this.config.assistedSuggest.config.highlightMatchesInSuggestions
                ? this.utils.generateHighlightedHtml(this.product.text, this.HandleShopInteractionService.getActiveInputValue())
                : this.utils.escapeUserProvidedText(this.product.text);
        },
        trackingParameters(): Record<string, string> {
            return {
                flTrackingCategory: `Assisted Suggest Click: ${this.config.blocks.product}`,
                flTrackingAction: this.product.text,
                flTrackingLabel: this.HandleShopInteractionService.getActiveInputValue(),
            };
        },
    },
});

export default product;
